import { useCallback } from "react";

import { Checkbox } from "@mui/material";

export interface IndexCheckboxProps {
	index: number;
	disabled: boolean;
	status: boolean | undefined;
	onChange: (index: number, checked: boolean) => void;
}

const IndexCheckbox: React.FC<IndexCheckboxProps> = (
	props: IndexCheckboxProps
) => {
	const handleChange = useCallback(
		(_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
			props.onChange(props.index, checked);
		},
		[props.index, props.onChange]
	);

	return (
		<Checkbox
			disabled={props.disabled}
			checked={props.status === true}
			indeterminate={props.status === undefined}
			onChange={handleChange}
		/>
	);
};

export default IndexCheckbox;
